import React from 'react'
import KenFormBuilder, { useKenFormStepper } from '../../components/KenFormBuilder'


export default function PgForm() {

    const { activeStep, setActiveStep, handleNext, handleBack } = useKenFormStepper();

    const formSubmits = [
        (values) => {
            console.log('Values from 0st : ', values);
            handleNext();
        },
        (values) => {
            console.log('Values from 1st : ', values);
            handleNext();
        },
        (values) => {
            console.log('Values from 2nd : ', values);
            handleNext()
        },
        (values) => {
            console.log('Values from 3rd : ', values);
            handleNext();
        },
        (values) => {
            console.log('Values from 4th : ', values);
            handleNext();
        },
        // (values) => {
        //     console.log('Values from 5th : ', values);
        //     handleNext();
        // },

    ];

    return (
        <div>
            <KenFormBuilder formSubmits={formSubmits}
                {...{ activeStep, setActiveStep, handleNext, handleBack }}
            />
        </div>
    )
}
